import { getInitialState } from "../../utils";
import { getPath } from "../../utils";

const initialState = {
  orderDetails: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ORDER_DETAILS":
      return setOrderDetails(state, action);
    default:
      return state;
  }
}

const setOrderDetails = (state, action) => {
  return {
    ...state,
    orderDetails: getPath(action.payload, "data", []),
  };
};
